exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput[type=range] {\n\tmargin-top: 12px;\n}\n\ninput[type=color] {\n\twidth: 64px;\n\tpadding: 2px;\n}\n\nform {\n\tmargin-top: 24px;\n}\n\n.btn { \n\tmargin-right: 12px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/advanced/param-editor/param-editor.css
// module id = 1377
// module chunks = 2